import { setHome } from '@/store/slices/layoutSlice'

interface Store {
  dispatch: (action: any) => void
}

interface SetRouteParams {
  store: Store
}

export const setRoute = ({ store }: SetRouteParams): void => {
  const path = window.location.hash.split('/')
  const rxuuid = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/

  // set property detail if url matches
  if (path[1] === 'invite') {
    if (path[2] && path[2].match(rxuuid)) {
      store.dispatch(setHome({ route: `/invite/${path[2]}` }))
    }
  }
  // always fall back to home
  else {
    store.dispatch(setHome({ route: '/' }))
  }
}